"use client";
import React, { useState } from "react";
import { searchChannel } from "./../../api/youtubeApi"; // Đảm bảo đường dẫn đúng
import { createReviewChannel } from "./../../api/reviewChannelApi"; // Đảm bảo đường dẫn đúng
import { useUser } from "./../../context/UserContext";

export const ReviewForm = ({ accents, reviewtags, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    accentId: "",
    reviewTagId: "",
    channelName: "",
    review: "",
  });

  const [errors, setErrors] = useState({});
  const { user } = useUser();
  const [channelInfo, setChannelInfo] = useState([]); // Thêm state để lưu thông tin kênh
  const [selectedChannel, setSelectedChannel] = useState(null); // Thêm state để lưu thông tin kênh

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error when field is edited
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    debugger;

    if (!formData.reviewTagId) {
      newErrors.reviewTagId = "Vui lòng chọn 1 hashtag";
    }

    if (!formData.channelName.trim()) {
      newErrors.channelName = "Vui lòng điền tên kênh cần tìm";
    }


    if (!formData.review.trim()) {
      newErrors.review = "Review bắt buộc nhập";
    } else if (formData.review.trim().length < 10) {
      newErrors.review = "Review cần có ít nhất 10 ký tự";
    }
    if (!selectedChannel) {
      newErrors.channelName = "Chọn ít nhất 1 kênh để review";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        let data = {
          userId: user.guid,
          ReviewTagIds: [formData.reviewTagId],
          AccentId: formData.accentId,
          ChannelId: selectedChannel.channelId,
          ChannelName: selectedChannel.nhannelName,
          Description: selectedChannel.description,
          Thumbnail: selectedChannel.thumbnail,
          SubscriberCount: selectedChannel.subscriberCount,
          VideoCount: selectedChannel.videoCount,
          ViewCount: selectedChannel.viewCount,
          CustomUrl: selectedChannel.customUrl,
          Country: selectedChannel.country,
          Review: formData.review,
        }
        await createReviewChannel(data);
      } catch (error) {
        console.error("Error marking post as read/unread", error);
      }
    }
  };

  const handleSearchChannel = async () => {
    try {
      const result = await searchChannel(formData.channelName);
      setChannelInfo(result);
    } catch (error) {
      console.error("Error searching channel:", error);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md mb-8">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">
        Create New Review
      </h2>

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label
            htmlFor="accentId"
            className="block mb-2 text-sm font-medium text-gray-700"
          >
            Giọng
          </label>
          <select
            id="accentId"
            name="accentId"
            value={formData.accentId}
            onChange={handleChange}
            className={`bg-gray-50 border ${errors.accentId ? "border-red-500" : "border-gray-300"} text-gray-900 text-sm rounded-lg focus:ring-rose-500 focus:border-rose-500 block w-full p-2.5`}
          >
            <option value="">Chọn 1 giọng</option>
            {accents && accents.map((accent) => (
              <option key={accent.id} value={accent.id}>
                {accent.name}
              </option>
            ))}
          </select>
          {errors.accentId && (
            <p className="mt-1 text-sm text-red-500">{errors.accentId}</p>
          )}
        </div>
        <div className="mb-4">
          <label
            htmlFor="reviewTagId"
            className="block mb-2 text-sm font-medium text-gray-700"
          >
            Hash Tag
          </label>
          <select
            id="reviewTagId"
            name="reviewTagId"
            value={formData.reviewTagId}
            onChange={handleChange}
            className={`bg-gray-50 border ${errors.reviewTagId ? "border-red-500" : "border-gray-300"} text-gray-900 text-sm rounded-lg focus:ring-rose-500 focus:border-rose-500 block w-full p-2.5`}
          >
            <option value="">Chọn 1 hashtag</option>
            {reviewtags && reviewtags.map((tag) => (
              <option key={tag.id} value={tag.id}>
                {tag.name}
              </option>
            ))}
          </select>
          {errors.reviewTagId && (
            <p className="mt-1 text-sm text-red-500">{errors.reviewTagId}</p>
          )}
        </div>

        <div className="mb-4">
          <label
            htmlFor="channelName"
            className="block mb-2 text-sm font-medium text-gray-700"
          >
            Channel Name
          </label>
          <div className="flex items-center">
            <input
              type="text"
              id="channelName"
              name="channelName"
              value={formData.channelName}
              onChange={handleChange}
              className={`bg-gray-50 border ${errors.channelName ? "border-red-500" : "border-gray-300"} text-gray-900 text-sm rounded-lg focus:ring-rose-500 focus:border-rose-500 block w-full p-2.5`}
              placeholder="Enter YouTube channel name"
            />
            <button
              type="button"
              onClick={handleSearchChannel}
              className="ml-2 px-1 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
            >
              Tìm kiếm kênh
            </button>
          </div>
          {errors.channelName && (
            <p className="mt-1 text-sm text-red-500">{errors.channelName}</p>
          )}
          {channelInfo.length > 0 && (
            <div className="mt-4 grid grid-cols-1 md:grid-cols-5 lg:grid-cols-5 gap-8">
              {channelInfo.map((channel, index) => (
                <div key={index} className={" p-4 rounded-lg shadow hover:shadow-lg " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "bg-rose-600" : "bg-white"}`} onClick={() => {
                  debugger;
                  setSelectedChannel(channel)
                }}>
                  <img src={channel.thumbnail} alt="Channel Thumbnail" className="w-full h-32 object-cover rounded-lg" />
                  <div className="p-4">
                    <h3 className={"text-sm font-semibold mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>{channel.title}</h3>
                    {/* <p className="text-sm text-gray-600 mb-2">{channel.description}</p> */}
                    <p className={"text-sm mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>Subscribers: {channel.subscriberCount}</p>
                    <p className={"text-sm mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>Videos: {channel.videoCount}</p>
                    <p className={"text-sm mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>Views: {channel.viewCount}</p>
                    <p className={"text-sm mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>Country: {channel.countryName}</p>
                    <a href={channel.youtubeUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline mt-2 block">
                      Visit Channel
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>


        <div className="mb-6">
          <label
            htmlFor="review"
            className="block mb-2 text-sm font-medium text-gray-700"
          >
            Review
          </label>
          <textarea
            id="review"
            name="review"
            value={formData.review}
            onChange={handleChange}
            rows="4"
            className={`bg-gray-50 border ${errors.review ? "border-red-500" : "border-gray-300"} text-gray-900 text-sm rounded-lg focus:ring-rose-500 focus:border-rose-500 block w-full p-2.5`}
            placeholder="Write your review here..."
          ></textarea>
          {errors.review && (
            <p className="mt-1 text-sm text-red-500">{errors.review}</p>
          )}
        </div>

        <div className="flex gap-3 justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-sm font-medium text-white bg-rose-700 rounded-lg hover:bg-rose-800 focus:outline-none focus:ring-2 focus:ring-rose-300"
          >
            Submit Review
          </button>
        </div>
      </form>
    </div>
  );
};
